
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-03-19-uptrain-data-drift",
      function () {
        return require("private-next-pages/blogs/2023-03-19-uptrain-data-drift/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-03-19-uptrain-data-drift"])
      });
    }
  